import { Component, OnDestroy, OnInit } from "@angular/core";
import { CommunityService } from "../../shared/services/community/community.service";
import { Subscription } from "rxjs/Subscription";
import { ActivatedRoute } from "@angular/router";
import { LoaderService } from "../../shared/services/loader.service";
import { Community } from "./../../shared/services/community/community";

@Component({
  selector: "app-select-community",
  templateUrl: "./select-community.component.html",
  styleUrls: ["./select-community.component.css"]
})
export class SelectCommunityComponent implements OnInit, OnDestroy {
  communities: Array<Community>;
  page = 1;
  routeSubscription: Subscription;
  activeRouteIndex: number;
  query = "";

  constructor(
    private communityService: CommunityService,
    private route: ActivatedRoute,
    private loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    this.loaderService.startLoader();
    this.routeSubscription = this.route.params.subscribe(
      params => (this.activeRouteIndex = params.index)
    );
    this.communityService.getCommunities().subscribe(
      communities => {
        communities.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          return 0;
        });

        this.communities = communities;
      }
    );
    this.loaderService.stopLoader();
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/bill/select-community/select-community.component.ts